import { BravoUser } from '../../bravoTypes';
import {preferredBandLocation, sessionKeyLocation} from '../../constants';
import { localRetrieveJSON, sessionRetrieveJSON, sessionStoreJSON } from '../../util/util';
import { UserAction } from '../actions/user';

export type UserState = {
    token?: string | null;
    profile?: BravoUser;
    preferredBand?: string | null;
};

const initialState:UserState = {
    token: sessionRetrieveJSON(sessionKeyLocation), // session token, to be provided in the authorization header.
    preferredBand: localRetrieveJSON(preferredBandLocation)
};

export default function userInfoReducer (state = initialState, action:UserAction){
    switch(action.type){
        case "user.token":
            const token = action.payload;
            if(token === null){
                sessionStorage.removeItem(sessionKeyLocation);
            }
            sessionStoreJSON(sessionKeyLocation, token);
            return {
                ...state,
                token: token == null? undefined : token,
                ready: true,
                error: null
            };
        case "user.profile":
            return {
                ...state,
                profile: action.payload
            }
        case "user.preferredBand":
            return {
                ...state,
                preferredBand: action.payload
            }
        default:
            return state;
    }
}